var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[_vm._v(" This is an about page ")])}
var staticRenderFns = []

export { render, staticRenderFns }